/**
 * @param {string} url 请求地址
 * @param {object} data 请求参数
 * @param {string} method 请求方法
 */
const request = (url, data, method) => {
	
	return new Promise((resole, reject) => {
		// https://dmtest.ahapp.net/preselect_interface/
		// https://dm.ahapp.net/preselect_interface/
		// http://mjyx.doumee.com/preselect_interface/
		// http://yx.doumee.com/preselect_interface/
		// http://127.0.0.1/interface/
		uni.request({
			url: `http://192.168.0.15:10012/${url}`,
			method,
		    data,
			header: {
				'content-type': 'application/json',
				'Access-Control-Allow-Origin': '*'
			},
		    success: (res) => {
				if (res.data.code === 200) {
					resole(res.data)
				} else {
					reject()
				}
		    },
			fail(err) {
				reject()
			}
		})
	})
}

const get = (url, data) => request(url, data, 'GET')

const post = (url, data) => request(url, data, 'POST')

export {
	get, post
}